/* ============================================================
   arthene — Formularseiten (Beratungsanfrage, Schätzung)
   Portiert aus prototypes/assets/beratungsanfrage.js und schaetzung.js.

   Wichtiger Unterschied zum Prototyp: hier wird das Absenden NICHT
   abgefangen. Ist alles ausgefüllt, geht das Formular ganz normal an
   sein Ziel (Shopify /contact bzw. der externe Endpoint der Schätzung).
   Diese Datei prüft nur vorher und meldet Fehler — ohne JavaScript
   funktionieren die Formulare weiterhin, dann prüft der Server.

   Seit dem Umbau auf Schritte gilt dasselbe Prinzip für die Aufteilung:
   Ohne JavaScript stehen alle Abschnitte untereinander auf einer Seite und
   sind vollständig ausfüllbar. Erst dieses Skript macht daraus einen Weg
   von Seite zu Seite — ein Abschnitt zur Zeit, "Weiter" prüft, bevor es
   weitergeht, und der Zurück-Knopf des Browsers führt einen Schritt zurück.
   ============================================================ */
(function () {
  'use strict';

  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  /* Diese Datei rendert kein Liquid und kennt die Sprache deshalb nicht. Die
     Sections hängen die Texte an ein leeres Element (data-arthene-formular-
     texte); hier werden sie abgelesen. Fehlt das Element, bleibt der deutsche
     Rückfall stehen und die Seite läuft einsprachig weiter. Je Seite gibt es
     nur ein Formular, deshalb genügt die Suche im ganzen Dokument. */
  function meldungstext(name, rueckfall) {
    var quelle = document.querySelector('[data-arthene-formular-texte]');
    return (quelle && quelle.getAttribute('data-' + name)) || rueckfall;
  }

  function fieldWrap(el) { return el.closest('[data-field]'); }

  function setError(el, message) {
    var wrap = fieldWrap(el);
    if (!wrap) return;
    var out = wrap.querySelector('[data-err]');
    if (message) {
      wrap.classList.add('is-invalid');
      el.setAttribute('aria-invalid', 'true');
      if (out) out.textContent = message;
    } else {
      wrap.classList.remove('is-invalid');
      el.removeAttribute('aria-invalid');
      if (out) out.textContent = '';
    }
  }

  function labelOf(el) {
    var wrap = fieldWrap(el);
    var label = wrap && wrap.querySelector('.f__label');
    if (label) {
      /* Zusätze wie „optional" und das Pflicht-Sternchen stehen in eigenen
         Elementen. Sie werden über ihre Klasse entfernt statt über den
         Wortlaut — nur so bleibt die Beschriftung in jeder Sprache sauber. */
      var kopie = label.cloneNode(true);
      kopie.querySelectorAll('.f__opt, .f__req').forEach(function (zusatz) {
        zusatz.remove();
      });
      var rein = kopie.textContent.replace(/\s+/g, ' ').trim();
      if (rein) return rein;
    }

    /* Kästchen wie die Datenschutz-Zustimmung tragen keine eigene
       Beschriftung, sondern stehen mitten im Satz. Dann tut es der Anfang
       dieses Satzes — „Dieses Feld" sagt niemandem etwas. */
    var eigenes = el.closest('label');
    if (eigenes) {
      var text = eigenes.textContent.replace(/\s+/g, ' ').replace('*', '').trim();
      if (text.length > 64) text = text.slice(0, 64).replace(/\s+\S*$/, '') + ' …';
      if (text) return text;
    }
    return meldungstext('dieses-feld', 'Dieses Feld');
  }

  function validate(el) {
    var value = (el.value || '').trim();
    /* Ein eigener Text am Feld gewinnt — er ist immer genauer als der
       zusammengesetzte. */
    var eigen = el.getAttribute('data-fehlertext');
    if (el.type === 'checkbox') {
      if (el.checked) return '';
      return eigen || meldungstext('bestaetigen', 'Bitte bestätigen: {{ feld }}')
        .replace('{{ feld }}', labelOf(el));
    }
    /* Ein Platzhalter statt zweier Bruchstücke: die Beschriftung steht im
       Deutschen vorn, in anderen Sprachen nicht unbedingt. */
    if (!value) return eigen || meldungstext('feld-fehlt', '{{ feld }} fehlt.')
      .replace('{{ feld }}', labelOf(el));
    if (el.type === 'email' && !EMAIL.test(value)) {
      return meldungstext('email', 'Bitte eine gültige E-Mail-Adresse angeben.');
    }
    return '';
  }

  function initForm(form) {
    if (form.dataset.artheneFormReady === '1') return;
    form.dataset.artheneFormReady = '1';

    var summary = document.getElementById('errorSummary');
    var summaryList = document.getElementById('errorSummaryList');
    var required = Array.prototype.slice.call(form.querySelectorAll('[data-required]'));
    var requiredGroups = Array.prototype.slice.call(form.querySelectorAll('[data-required-group]'));

    /* ---- Zeichenzähler ---- */
    form.querySelectorAll('[data-count-for]').forEach(function (out) {
      var target = document.getElementById(out.getAttribute('data-count-for'));
      if (!target) return;
      var sync = function () { out.textContent = target.value.length; };
      target.addEventListener('input', sync);
      sync();
    });

    /* ---- Fehler beim Tippen wieder aufheben ---- */
    form.querySelectorAll('input, select, textarea').forEach(function (el) {
      var clear = function () { setError(el, ''); };
      el.addEventListener('input', clear);
      el.addEventListener('change', clear);
    });

    /* ---- Entwurf lokal sichern ---- */
    var draftKey = 'arthene:' + (form.id || 'formular') + ':entwurf';
    var draftNote = document.getElementById('draftNote');
    var clearDraft = document.getElementById('clearDraft');
    var draftFields = function () {
      return Array.prototype.slice.call(
        form.querySelectorAll('input:not([type=file]):not([type=hidden]), select, textarea')
      );
    };

    function saveDraft() {
      var data = {};
      draftFields().forEach(function (el) {
        if (!el.id) return;
        if (el.type === 'checkbox') data[el.id] = el.checked;
        else if (el.type === 'radio') { if (el.checked) data['radio:' + el.name] = el.value; }
        else data[el.id] = el.value;
      });
      try {
        localStorage.setItem(draftKey, JSON.stringify(data));
        if (draftNote) draftNote.hidden = false;
      } catch (_) { /* Speicher voll oder blockiert */ }
    }

    function loadDraft() {
      var data;
      try { data = JSON.parse(localStorage.getItem(draftKey) || 'null'); } catch (_) { return; }
      if (!data) return;
      Object.keys(data).forEach(function (key) {
        if (key.indexOf('radio:') === 0) {
          var name = key.slice(6);
          var radio = form.querySelector('input[name="' + name + '"][value="' + data[key] + '"]');
          if (radio) radio.checked = true;
          return;
        }
        var el = document.getElementById(key);
        if (!el) return;
        if (el.type === 'checkbox') el.checked = !!data[key];
        else el.value = data[key];
      });
      if (draftNote) draftNote.hidden = false;
      form.querySelectorAll('[data-count-for]').forEach(function (out) {
        var target = document.getElementById(out.getAttribute('data-count-for'));
        if (target) out.textContent = target.value.length;
      });
    }

    var saveTimer;
    form.addEventListener('input', function () {
      clearTimeout(saveTimer);
      saveTimer = setTimeout(saveDraft, 500);
    });
    if (clearDraft) {
      clearDraft.addEventListener('click', function () {
        try { localStorage.removeItem(draftKey); } catch (_) {}
        form.reset();
        form.querySelectorAll('.is-invalid').forEach(function (w) { w.classList.remove('is-invalid'); });
        if (draftNote) draftNote.hidden = true;
      });
    }
    loadDraft();

    /* ---- Prüfen ----
       bereich = das ganze Formular (beim Absenden) oder ein einzelner
       Abschnitt (beim Weiterklicken). Gibt die Fehler zurück, statt sie
       selbst anzuzeigen — das übernimmt zeigeFehler(). */
    function pruefe(bereich) {
      var errors = [];

      required.forEach(function (el) {
        if (!bereich.contains(el)) return;
        var msg = validate(el);
        setError(el, msg);
        if (msg) errors.push({ el: el, msg: msg });
      });

      requiredGroups.forEach(function (group) {
        if (!bereich.contains(group)) return;
        var checked = group.querySelectorAll('input[type=checkbox]:checked').length;
        var wrap = fieldWrap(group) || group.closest('.f');
        var out = wrap && wrap.querySelector('[data-err]');
        if (checked === 0) {
          var leer = meldungstext('gruppe', 'Bitte mindestens einen Punkt wählen.');
          if (wrap) wrap.classList.add('is-invalid');
          if (out) out.textContent = leer;
          errors.push({ el: group.querySelector('input'), msg: leer });
        } else {
          if (wrap) wrap.classList.remove('is-invalid');
          if (out) out.textContent = '';
        }
      });

      return errors;
    }

    function zeigeFehler(errors) {
      if (!summary || !summaryList) return;
      summaryList.innerHTML = '';
      errors.forEach(function (err) {
        var li = document.createElement('li');
        if (err.el && err.el.id) {
          var a = document.createElement('a');
          a.href = '#' + err.el.id;
          a.textContent = err.msg;
          a.addEventListener('click', function (ev) { ev.preventDefault(); err.el.focus(); });
          li.appendChild(a);
        } else {
          li.textContent = err.msg;
        }
        summaryList.appendChild(li);
      });
      summary.classList.add('is-visible');
      summary.focus();
      summary.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function versteckeFehler() {
      if (!summary || !summaryList) return;
      summary.classList.remove('is-visible');
      summaryList.innerHTML = '';
    }

    /* ---- Ein Abschnitt zur Zeit ---- */
    var schritte = initSchritte(form, pruefe, zeigeFehler, versteckeFehler);

    /* ---- Prüfen vor dem Absenden ---- */
    form.addEventListener('submit', function (e) {
      var errors = pruefe(form);

      if (!errors.length) {
        /* Alles in Ordnung: normal absenden. Entwurf wird nicht mehr gebraucht. */
        try { localStorage.removeItem(draftKey); } catch (_) {}
        return;
      }

      e.preventDefault();
      /* Der erste Fehler kann in einem Abschnitt stehen, der gerade nicht zu
         sehen ist — dann erst dorthin wechseln. */
      if (schritte) schritte.zeigeFeld(errors[0].el);
      zeigeFehler(errors);
    });
  }

  /* ========================================================
     Ein Abschnitt zur Zeit

     Die Abschnitte (.fset) stehen im HTML untereinander. Hier wird daraus
     ein Weg: nur einer ist sichtbar, "Weiter" prüft ihn, bevor es
     weitergeht, "Zurück" führt zum vorigen. Jeder Wechsel legt einen
     Eintrag im Verlauf an — der Zurück-Knopf des Browsers tut damit das,
     was er auf getrennten Seiten täte.

     Der Absenden-Knopf steht im letzten Abschnitt und bleibt dort.
     ======================================================== */
  function initSchritte(form, pruefe, zeigeFehler, versteckeFehler) {
    var fsets = Array.prototype.slice.call(form.querySelectorAll('.fset'));
    if (fsets.length < 2) return null;

    var sform = form.closest('.sform');
    if (sform) sform.classList.add('is-schritte');

    var stepsList = document.getElementById('stepsList');
    var stepLinks = stepsList
      ? Array.prototype.slice.call(stepsList.querySelectorAll('a'))
      : [];

    var aktuell = 0;
    var weiteste = 0; // wie weit man schon war — nur dorthin darf man springen

    var nav = document.createElement('div');
    nav.className = 'schrittnav';
    nav.innerHTML =
      '<button class="btn btn--ghost schrittnav__zurueck" type="button">' +
        '<span class="arw" aria-hidden="true">&larr;</span> ' +
        meldungstext('zurueck', 'Zurück') + '</button>' +
      '<p class="schrittnav__stand" aria-live="polite"></p>' +
      '<button class="btn schrittnav__weiter" type="button">' +
        meldungstext('weiter', 'Weiter') +
        ' <span class="arw" aria-hidden="true">&rarr;</span></button>';
    fsets[fsets.length - 1].insertAdjacentElement('afterend', nav);

    var zurueckBtn = nav.querySelector('.schrittnav__zurueck');
    var weiterBtn = nav.querySelector('.schrittnav__weiter');
    var stand = nav.querySelector('.schrittnav__stand');

    function zeichne() {
      fsets.forEach(function (fset, i) {
        fset.hidden = i !== aktuell;
      });
      zurueckBtn.hidden = aktuell === 0;
      weiterBtn.hidden = aktuell === fsets.length - 1;
      /* Ein Schlüssel mit zwei Platzhaltern statt dreier Bruchstücke: die
         Wortstellung von „Schritt 2 von 5" ist nicht in jeder Sprache gleich. */
      stand.textContent = meldungstext('stand', 'Schritt {{ nummer }} von {{ anzahl }}')
        .replace('{{ nummer }}', aktuell + 1)
        .replace('{{ anzahl }}', fsets.length);

      stepLinks.forEach(function (a, i) {
        a.setAttribute('aria-current', String(i === aktuell));
        a.classList.toggle('is-erledigt', i < aktuell);
        /* Vorwärts springen erst, wenn der Schritt schon einmal erreicht war —
           sonst ließe sich die Prüfung umgehen. */
        a.classList.toggle('is-gesperrt', i > weiteste);
      });
    }

    function geheZu(ziel, mitVerlauf) {
      if (ziel < 0 || ziel >= fsets.length) return;
      aktuell = ziel;
      if (ziel > weiteste) weiteste = ziel;
      versteckeFehler();
      zeichne();

      var kopf = sform || form;
      var oben = kopf.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: Math.max(oben, 0), behavior: 'smooth' });

      /* Der Titel bekommt den Fokus, damit Screenreader den Wechsel
         mitbekommen — wie beim Aufruf einer neuen Seite. */
      var titel = fsets[aktuell].querySelector('.fset__title');
      if (titel) {
        titel.setAttribute('tabindex', '-1');
        titel.focus({ preventScroll: true });
      }

      if (mitVerlauf && window.history && history.pushState) {
        history.pushState({ artheneSchritt: aktuell }, '', '#' + fsets[aktuell].id);
      }
    }

    weiterBtn.addEventListener('click', function () {
      var errors = pruefe(fsets[aktuell]);
      if (errors.length) {
        zeigeFehler(errors);
        return;
      }
      geheZu(aktuell + 1, true);
    });

    zurueckBtn.addEventListener('click', function () {
      /* Wenn der Verlaufseintrag von uns stammt, den Browser zurückgehen
         lassen — sonst wüchse der Verlauf bei jedem Hin und Her weiter. */
      if (window.history && history.state && history.state.artheneSchritt === aktuell && aktuell > 0) {
        history.back();
      } else {
        geheZu(aktuell - 1, true);
      }
    });

    stepLinks.forEach(function (a, i) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        if (i > weiteste) return;
        if (i > aktuell) {
          var errors = pruefe(fsets[aktuell]);
          if (errors.length) { zeigeFehler(errors); return; }
        }
        geheZu(i, true);
      });
    });

    window.addEventListener('popstate', function (e) {
      var ziel = e.state && typeof e.state.artheneSchritt === 'number' ? e.state.artheneSchritt : 0;
      aktuell = Math.min(Math.max(ziel, 0), fsets.length - 1);
      versteckeFehler();
      zeichne();
    });

    zeichne();
    if (window.history && history.replaceState) {
      history.replaceState({ artheneSchritt: 0 }, '', location.pathname + location.search);
    }

    return {
      /* Springt zu dem Abschnitt, in dem das Feld steht — für Fehler, die
         der Server erst nach dem Absenden meldet. */
      zeigeFeld: function (el) {
        if (!el) return;
        for (var i = 0; i < fsets.length; i++) {
          if (fsets[i].contains(el)) {
            if (i !== aktuell) geheZu(i, false);
            return;
          }
        }
      }
    };
  }

  function init() {
    document.querySelectorAll(
      'form[id="beratungForm"], form[id="schaetzungForm"], form[id="kontaktForm"]'
    ).forEach(initForm);

    /* Shopify hat die Seite nach erfolgreichem Absenden neu geladen und im
       Formular einen Marker gesetzt (das form-Objekt gibt es nur dort).
       Jetzt Formular ausblenden und Bestätigung zeigen. */
    if (!document.querySelector('[data-form-success]')) return;
    var wrapper = document.querySelector('.sform');
    var done = document.getElementById('done');
    if (wrapper) wrapper.classList.add('is-done');
    if (done) {
      done.classList.add('is-visible');
      done.focus();
      done.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    /* Der Entwurf hat seinen Zweck erfüllt. */
    try {
      Object.keys(localStorage).forEach(function (k) {
        if (k.indexOf('arthene:') === 0 && k.indexOf(':entwurf') > 0) localStorage.removeItem(k);
      });
    } catch (_) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
